/**
 * @description
 * Objeto DataExternal
 */

import { AuxiliarAOC } from "./auxiliaraoc.model";
import { PersonsByIdNumCtrlDig } from "./personsByIdNumCtrlDig.model";
import { Representants } from "./representants.model";
import { RepresentantsAOC } from "./representantsaoc.model";

export class DataExternal {

    public dboid: string = "";
    public tercer: PersonsByIdNumCtrlDig[] = new Array<PersonsByIdNumCtrlDig>();
    public representant: string | null = null;
    public representants: Representants[] = new Array<Representants>();
    public representantAOC: AuxiliarAOC | null = null;
    public representantsAOC: RepresentantsAOC[] = new Array<RepresentantsAOC>();
  
    constructor() {}
}